export default __webpack_public_path__ + "static/media/ic-dl-lecture-videos.b6b68c8b.svg";